import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../supabase';
import useSocialUser from './useSocialUser';

function readCreatorUid() {
  try { return JSON.parse(localStorage.getItem('findish_creator'))?.uid || null; }
  catch { return null; }
}

export default function useSavedCount() {
  const socialUser = useSocialUser();
  const [creatorUid, setCreatorUid] = useState(readCreatorUid);
  const uid = socialUser?.uid || creatorUid || null;

  const [count, setCount] = useState(0);

  useEffect(() => {
    const sync = () => setCreatorUid(readCreatorUid());
    window.addEventListener('findish-social-changed', sync);
    return () => window.removeEventListener('findish-social-changed', sync);
  }, []);

  const fetchCount = useCallback(async () => {
    if (!uid) { setCount(0); return; }
    const { count: c } = await supabase
      .from('bookmarks')
      .select('*', { count: 'exact', head: true })
      .eq('user_id', uid)
      .eq('bookmarked', true);
    setCount(c || 0);
  }, [uid]);

  useEffect(() => { fetchCount(); }, [fetchCount]);

  useEffect(() => {
    const handler = (e) => {
      if (e?.detail && typeof e.detail.count === 'number') setCount(e.detail.count);
      else fetchCount();
    };
    window.addEventListener('findish-bookmarks-changed', handler);
    return () => window.removeEventListener('findish-bookmarks-changed', handler);
  }, [fetchCount]);

  return count;
}

export function notifyBookmarksChanged(count) {
  window.dispatchEvent(new CustomEvent('findish-bookmarks-changed',
    typeof count === 'number' ? { detail: { count } } : undefined
  ));
}
